// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-dd-menu .router-link-active[data-v-90f28c14]:after{display:none}", ""]);
// Exports
module.exports = exports;
